export default __webpack_public_path__ + "static/media/onion.daf1a5ed.svg";